<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav 
            [visible]="false" 
            (updatePostpaid)="this.postpago=$event" 
            (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event" 
            (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event" 
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize">
        <div class="container" *ngIf="this.screenView==1">
            <div class="basicrow">
                <div class="container">
                    <div class="fulltitle m-top-i f-btitle">
                        <span class="icon-dash-21"></span> Programa Refiere y Gana
                    </div>
                </div>
            </div>
            <div class="basicrow">
                <div class="container nocont">
                    <div class="basicrow rel m-top-i">
                        <img width="100%" class="innerban" src="../../../assets/images/refbanimg.jpg">
                        <div class="innerbantexts">
                            <div class="basicrow f-black roboto-l texto">
                                Por cada amigo que refieras<br />
                                <span class="f-reg f-mgray">Obtendras cupones</span>
                            </div>
                            <div class="basicrow">
                                <div (click)="this.viewRefer();" class="btns blue refdef vcenter">
                                    <span class="tabcell">
                                        Refiere&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div (click)="this.viewRedeem();" class="btns blue refdef refdefleft vcenter">
                                    <span class="tabcell">
                                        Redimir&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow m-top-i lessm">
                <div class="container">
                    <div class="basicrow m-top-i">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 roboto-l f-black text-justify">
                                <span class="f-big less-f">&#191;Qu&eacute; es el programa de Refiere y
                                    Gana&#63;
                                </span><br /><br />
                                <span class="f-reg-i f-mgray">Este programa tiene el objetivo de incentivar a nuestros
                                    clientes existentes por cada referido a amigos, familiares y
                                    conocidos que culmine en una activación de servicio. Por otro lado, el cliente
                                    referido recibirá beneficios por su
                                    activación. Todas las transacciones se gestionarán y monitorearán a través de Mi
                                    Claro, permitiéndole al cliente
                                    autogestión de sus beneficios.
                                </span>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-7 text-center">
                                <img width="60%" class="reflaptimg" src="../../../assets/images/reflaptopimg.jpg">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow graybg" *ngIf="this.screenView==1">
            <div class="container">
                <div class="basicrow">
                    <div class="row refdef">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="basicrow text-center">
                                <img style="font-size: 4em;cursor: pointer;width: auto;height: 90px;" src="../../../assets/images/ico_preguntasFrecuentes.png" alt="icono_questions"
                                    (click)="this.mostrarPreguntasFrecuentes()">
                            </div>
                            <div class="basicrow f-black roboto-l text-justify m-top">
                                <div class="basicrow f-mildt text-center" style="cursor: pointer;"
                                    (click)="this.mostrarPreguntasFrecuentes()">
                                    Preguntas Frecuentes
                                </div>

                                <div class="f-reg roboto-r f-black basicrow m-top">
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 hrefmtop">
                            <div class="basicrow text-center">
                                <img style="font-size: 4em;cursor: pointer;width: auto;height: 90px;" src="../../../assets/images/ico_terminosCondiciones.png" alt="icono_terms" (click)="this.mostarTerminos()">
                            </div>
                            <div class="basicrow f-black roboto-l text-justify m-top">
                                <div class="basicrow f-mildt text-center" style="cursor: pointer;"
                                    (click)="this.mostarTerminos()">
                                    Términos y Condiciones
                                </div>
                                <div class="f-reg roboto-r f-black basicrow m-top">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" *ngIf="this.screenView==2">
            <app-referred-frequent-questions 
                (updatescreenview)="this.screenView=$event">
            </app-referred-frequent-questions>
        </div>
    </div>
    <app-footer></app-footer>
</div>